import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CONFIG } from '../../helper/app-config';
import { MatDialog } from '@angular/material/dialog';
import { filter, Observable, SubscriptionLike } from 'rxjs';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { AdminUpdateGuidelinesDialogComponent } from '../admin-update-guidelines-dialog/admin-update-guidelines-dialog.component';
import { table } from 'console';
import { ConfirmDialogModalComponent } from '../confirm-dialog-modal/confirm-dialog-modal.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-admin-update-guidelines',
  templateUrl: './admin-update-guidelines.component.html',
  styleUrl: './admin-update-guidelines.component.css',
})
export class AdminUpdateGuidelinesComponent implements OnInit {
  dataSource = new MatTableDataSource();
  columns = [
    'channel',
    'cooler',
    'Guidelines 1',
    'Guidelines 2',
    'Guidelines 3',
    'Guidelines 4',
    'dropdown',
  ];
  guidelinesColumn = [
    'Guidelines 1',
    'Guidelines 2',
    'Guidelines 3',
    'Guidelines 4',
  ];
  CONFIG = CONFIG;
  channels: any = [];
  selectedChannel: string[] = [];
  selectedCooler: string[] = [];
  coolers: any = [];
  filteredData: any;
  allChannelsSelected = false;
  allCoolerSelected = false;
  selectedBottlers: any = [];
  minimum_facings: number = 0;
  bottlerOptions = [
    'BBPL Dankuni',
    'DBPL Taratala',
    'Enrich Delhi-NCR',
    'Enrich Rajasthan',
    'HCCB AP',
    'HCCB Orissa',
    'HCCB JH',
    'HCCB Gujarat',
  ];
  static_data = [
    {
      channel: 'E&D (Bakery & Chaat)',
      cooler: '12 Caser',
      selectedBottler: this.bottlerOptions[0],
    },
    {
      channel: 'E&D (Mass Eateries & QSR)',
      cooler: '15 Caser',
      selectedBottler: this.bottlerOptions[0],
    },
    {
      channel: 'Grocery/Convenience',
      cooler: '30 Caser',
      selectedBottler: this.bottlerOptions[0],
    },
    {
      channel: 'OAG',
      cooler: '45 Caser',
      selectedBottler: this.bottlerOptions[0],
    },
  ];
  admin_guidelines_library_data_subscription: SubscriptionLike;
  admin_guidelines_library_data: any;
  admin_guidelines_library_data_modified: any;
  admin_guidelines_library_data_observable: Observable<any> =
    this.planogramState.admin_guidelines_library_data;
  is_show_loader: Observable<boolean> = this.planogramState.loader;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private planogramState: PlanogramStateService
  ) {
    this.planogramState.getGuidelinesLibraryData();
  }
  ngOnInit(): void {
    //this.dataSource.data = this.static_data;
    // this.filteredData = this.static_data;
    // this.dataSource.data = this.filteredData;
    this.adminGuidelinesLibraryDataSubscription();
  }

  adminGuidelinesLibraryDataSubscription() {
    this.admin_guidelines_library_data_subscription =
      this.admin_guidelines_library_data_observable.subscribe((response) => {
        this.minimum_facings = Number(response.minimum_facings);
        let res = response.versions_data;
        if (res && Object.values(res).length > 0) {
          this.admin_guidelines_library_data = res;
          this.setChannelCoolerBottlersForTable(res);
          console.log('res===========>', res);
        }
      });
  }

  setChannelCoolerBottlersForTable(data: any) {
    let channels = Object.keys(data);
    let table_data: any = [];
    channels.forEach((channel) => {
      let cooler = Object.keys(this.admin_guidelines_library_data[channel]);
      cooler.forEach((cooler) => {
        let obj: any = {};
        obj.channel = channel;
        obj.cooler_type = cooler;
        let bottlers = Object.keys(
          this.admin_guidelines_library_data[channel][cooler]
        );
        let selected_bottler_data: any =
          this.admin_guidelines_library_data[channel][cooler][bottlers[0]];
        obj.bottlers = bottlers;
        obj.selectedBottler = bottlers[0];
        obj.locked_guidelines = selected_bottler_data.active_version;
        obj.can_semi_locked = selected_bottler_data.can_semi_locked;
        table_data.push(obj);
        obj.guidelines = selected_bottler_data.guideline_versions;
      });
    });
    this.admin_guidelines_library_data_modified = table_data;
    this.filteredData = table_data;
    this.dataSource.data = this.filteredData;
    let data_length = data.length;
    this.getFiltersValues(channels);
    for (let i = 0; i < data_length; i++) {
      this.selectedBottlers[i] = this.getBottlersFromData(
        data[i].unitwise_versions
      )[0];
    }
  }

  updateLockedGuideline(
    channel: string,
    cooler: string,
    selectedBottler: string,
    lock_index: number
  ) {
    let selectedBottler_data =
      this.admin_guidelines_library_data[channel][cooler][selectedBottler];
    if (
      selectedBottler_data.guideline_versions.length > 0 &&
      selectedBottler_data.guideline_versions.length >= lock_index
    ) {
      this.admin_guidelines_library_data[channel][cooler][
        selectedBottler
      ].can_semi_locked = lock_index;
      this.setChannelCoolerBottlersForTable(this.admin_guidelines_library_data);
      console.log(
        'this.admin_guidelines_library_data',
        this.admin_guidelines_library_data
      );
    }
  }

  displayDate(data: string) {
    let d = new Date(data);
    let date = d.getDate();
    let month = d.getMonth();
    let year = d.getFullYear();
    return `${date}/${month + 1}/${year}`;
  }
  moveToSetUpScreen() {
    this.router.navigateByUrl(CONFIG.PATH.NEWPLANOGRAM);
  }

  viewVersionedGuidelines(
    channel: string,
    cooler: string,
    version: number,
    locked_guidelines: number,
    selectedBottler: string,
    planogram_id: number,
    guideline: string
  ) {
    let payload: any = {};
    payload.channel = channel;
    payload.cooler_type = cooler;
    payload.version = version + 1;
    payload.unit = selectedBottler;
    this.router.navigateByUrl(CONFIG.PATH.ADMIN_SETUP_SCREEN_NEW, {
      state: {
        payload: payload,
        planogram_id: planogram_id,
        screen_index: 1,
        from: 'admin-updates-guidelines',
        guideline_version_name: guideline,
      },
    });
  }

  openGuidelinesData(data: any) {
    if (data) {
      console.log('open data', data);
      const dialogRef = this.dialog.open(AdminUpdateGuidelinesDialogComponent, {
        height: '70%',
        width: '40%',
        data: data.assortment,
      });
    }
  }

  getFiltersValues(channels: any) {
    channels.forEach((channel: any) => {
      if (!this.channels.includes(channel)) {
        this.channels.push(channel);
        let cooler = Object.keys(this.admin_guidelines_library_data[channel]);
        cooler.forEach((cooler) => {
          if (!this.coolers.includes(cooler)) {
            this.coolers.push(cooler);
          }
        });
      }
      // if (!this.channels.includes(row.channel)) {
      //   this.channels.push(row.channel);
      // }
      // this.selectedChannel = this.channels;
      // if (!this.coolers.includes(row.channel)) {
      //   this.coolers.push(row.cooler_type);
      // }
    });
    this.selectedChannel = this.channels;
    this.allChannelsSelected = true;
    this.selectedCooler = this.coolers;
    this.allCoolerSelected = true;
  }


  checkAllSelected() {
    this.allChannelsSelected =
      this.selectedChannel.length == this.channels.length;
    this.allCoolerSelected = this.selectedCooler.length == this.coolers.length;
  }

  getBottlersFromData(data: any) {
    let keys = Object.keys(data);
    return keys;
  }

  toggleAllChannels() {
    this.allChannelsSelected = !this.allChannelsSelected;
    if (!this.allChannelsSelected) {
      this.selectedChannel = [];
    } else if (this.allChannelsSelected) {
      this.selectedChannel = this.channels;
    }
  }

  toggleAllCoolers() {
    this.allCoolerSelected = !this.allCoolerSelected;
    if (!this.allCoolerSelected) {
      this.selectedCooler = [];
    } else if (this.allCoolerSelected) {
      this.selectedCooler = this.coolers;
    }
    this.onSelectionChannelCoolerChange();
  }

  onSelectionChannelCoolerChange() {
    this.checkAllSelected();
    let dataFiltered = this.admin_guidelines_library_data_modified.filter(
      (row: any) =>
        (this.selectedChannel.length == 0
          ? this.channels.includes(row.channel)
          : this.selectedChannel.includes(row.channel)) &&
        (this.selectedCooler.length == 0
          ? this.coolers.includes(row.cooler_type)
          : this.selectedCooler.includes(row.cooler_type))
    );
    this.filteredData = dataFiltered;
    this.dataSource.data = dataFiltered;
  }

  saveAllLockedGuidelines() {
    let required_config: any = [];
    this.admin_guidelines_library_data_modified.forEach((d: any) => {
      let active_version =
        this.admin_guidelines_library_data[d.channel][d.cooler_type][
          d.selectedBottler
        ].can_semi_locked;
      if (active_version && active_version !== 0) {
        let obj: any = {};
        obj.channel = d.channel;
        obj.unit = d.selectedBottler;
        obj.cooler_type = d.cooler_type;
        obj.version = active_version;
        required_config.push(obj);
      }
    });
    let payload: any = {};
    payload.guideline_combinations = required_config;
    this.planogramState.setLockedGuidelines(payload);
  }

  onBottlerSelectionChange(index: number, bottler: string) {
    this.filteredData[index].selectedBottler = bottler;
    let channel = this.filteredData[index].channel;
    let cooler_type = this.filteredData[index].cooler_type;
    this.filteredData[index].guidelines =
      this.admin_guidelines_library_data[channel][cooler_type][
        bottler
      ].guideline_versions;
    this.filteredData[index].locked_guidelines =
      this.admin_guidelines_library_data[channel][cooler_type][
        bottler
      ].active_version;
    this.dataSource.data = this.filteredData;
    console.log('this.filteredData', this.filteredData);
  }

  // selectPlanogram = (id:number)=>{

  //     this.dialog.open(ConfirmDialogModalComponent, {
  //       id: 'dialog2',
  //       height: '200px',
  //       width: '500px',
  //       data: {
  //         header_msg: 'Cannot select more than 3 planograms.',
  //         header_msg_description: 'Please clear existing selection to select other planograms.',
  //         ok_action: 'Continue'
  //       },
  //     });
  // }

  changeMinimumFacings() {
    Swal.fire({
      title: 'Change minimum facings',
      input: 'text',
      inputValue: this.minimum_facings,
      inputValidator: (value) => {
        const numberValue = Number(value);
        if (isNaN(numberValue) || numberValue < 0 || numberValue > 6) {
          return 'Please enter a number between 2 and 6!';
        }
        return null; // No error
      },
      confirmButtonText: 'Confirm',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      didOpen: () => {
        const inputField = document.getElementById(
          'number-input'
        ) as HTMLInputElement;
        if (inputField) inputField.focus();
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const inputValue = Number(result.value);
        if (inputValue !== this.minimum_facings) {
          let id = Number(localStorage.getItem('user_id'));
          this.planogramState.updateMinimumFacings(id, inputValue);
          this.planogramState.getGuidelinesLibraryData();
        }
        console.log('Confirmed value:', inputValue);
      }
    });
  }

  comparePlanograms(guidelines: any) {
    console.log('guidelines', guidelines);
    let guidelines_versioned = guidelines
      .filter((guideline: any) => guideline.planogram_id)
      .map((g: any) => g.planogram_id);
    if (guidelines_versioned.length > 1) {
      this.planogramState.comparePlanogram(guidelines_versioned, true);
    } else {
      this.dialog.open(ConfirmDialogModalComponent, {
        id: 'dialog2',
        height: '200px',
        width: '500px',
        data: {
          header_msg: 'Note',
          header_msg_description:
            'Atleast 2 versioned planogram must be there to compare',
          ok_action: 'Continue',
        },
      });
    }
    //this.dialogRef.close();
  }
}
